// Iter 770 (Kamel) — textes des pages « Qui sommes-nous » (/qui-sommes-nous) et « Infos pratiques » (/informations-administratives).
// Vide = texte standard ; **gras** ; 1 ligne = 1 paragraphe.
export const STATIQUES_TEXTES_DEFAULTS = {
  "home_slogan_1": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — bandeau : slogan (ligne 1)",
    "def": "✨ Des voyages pour tous ✨"
  },
  "home_slogan_2": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — bandeau : slogan (ligne 2)",
    "def": "Seuls, entre amis ou en famille"
  },
  "home_une_titre": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — « Voyages à la une » : titre",
    "def": "Voyages à la une"
  },
  "home_une_sous_titre": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — « Voyages à la une » : sous-titre",
    "def": "Découvrez nos destinations phares"
  },
  "home_pourquoi_titre": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — « Pourquoi voyager avec nous ? » : titre",
    "def": "Pourquoi voyager avec nous ?"
  },
  "home_pourquoi_texte": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — « Pourquoi voyager avec nous ? » : texte au-dessus de l'image (vide = rien)",
    "def": ""
  },
  "home_cta_titre": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — bloc du bas : titre",
    "def": "Prêt à partir à l'aventure ?"
  },
  "home_cta_texte": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Accueil — bloc du bas : phrase",
    "def": "Réservez dès maintenant votre prochain voyage !"
  },
  "footer_texte_1": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Bas de page — phrase 1",
    "def": "Des voyages pour tous, seuls, entre amis ou en famille depuis 1997."
  },
  "footer_texte_2": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Bas de page — phrase 2",
    "def": "Bientôt 30 ans d'expérience en 2027"
  },
  "footer_slogan": {
    "groupe": "Page d’accueil & bas de page",
    "label": "Bas de page — slogan (entre guillemets)",
    "def": "On ne se prend pas au sérieux, mais on est sérieux."
  },
  "about_hero_sous_titre": {
    "groupe": "Qui sommes-nous — En-tête & histoire",
    "label": "Bandeau — sous-titre",
    "def": "Rhône Amitié Voyages, bientôt 30 ans d'expérience au service de vos vacances"
  },
  "about_histoire_1": {
    "groupe": "Qui sommes-nous — En-tête & histoire",
    "label": "Notre Histoire — paragraphe 1",
    "def": "**Rhône Amitié Voyages** est un club de voyages associatif basé en région lyonnaise. L'aventure a commencé en **1997**, lorsque mon père a lancé des voyages collectifs comme activité de loisir, après une expérience précédente compliquée dans une autre structure."
  },
  "about_histoire_2": {
    "groupe": "Qui sommes-nous — En-tête & histoire",
    "label": "Notre Histoire — paragraphe 2",
    "def": "En **2009**, cette activité est devenue une entreprise professionnelle, tout en conservant ** l'esprit associatif et convivial** du départ. Aujourd'hui, nous approchons les **30 ans d'expérience** dans l'organisation de voyages en groupe."
  },
  "about_familial": {
    "groupe": "Qui sommes-nous — En-tête & histoire",
    "label": "Encadré « fonctionnement familial » — texte",
    "def": "Nous ne sommes pas une \"grosse usine à touristes\" : notre fonctionnement reste **familial, proche des gens**. Beaucoup de participants viennent de Lyon et sa région, mais aussi de Paris, Marseille, Dunkerque, Roubaix... Certains font des centaines de kilomètres pour voyager avec nous."
  },
  "about_confiance": {
    "groupe": "Qui sommes-nous — Valeurs",
    "label": "Confiance — texte",
    "def": "Hébergements, compagnies de transport, tarifs, conditions d'annulation, formalités : **tout est présenté clairement**. Pas de petites lignes, pas de surprises. Vous savez exactement à quoi vous vous engagez."
  },
  "about_securite": {
    "groupe": "Qui sommes-nous — Valeurs",
    "label": "Sécurité — texte",
    "def": "Partenaires sérieux, accompagnement adapté, **assurance multirisque voyage** proposée. En cas de question, réponse rapide via WhatsApp, puis par téléphone ou en rendez-vous si besoin."
  },
  "about_souplesse": {
    "groupe": "Qui sommes-nous — Valeurs",
    "label": "Souplesse — texte",
    "def": "Paiement échelonné, plusieurs modes acceptés (CB, virement, chèques-vacances ANCV, avoir), et un **accompagnement administratif personnalisé** pour vos passeports, visas et formulaires."
  },
  "about_ambiance_banniere": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "Bannière bleu foncé — texte",
    "def": "RHÔNE AMITIÉ VOYAGES, c'est 30 ans d'histoire, de voyages, de générations qui se croisent, et de familles qui se retrouvent. Entre Lyon et Saint-Étienne, on laisse le foot au stade, et on se met dans la même équipe : celle du voyage partagé."
  },
  "about_ambiance_intro": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "Citation en italique",
    "def": "Chez RHÔNE AMITIÉ VOYAGES, le voyage n'est pas seulement une destination, c'est aussi une façon de se retrouver. On part pour voir du pays, mais on revient surtout avec des rencontres, des rires, des souvenirs partagés. Voyager, c'est bien. Voyager ensemble, c'est encore mieux."
  },
  "about_ambiance_1": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "« L'ambiance avant tout » — texte",
    "def": "Ici, on visite des lieux, on découvre des paysages, on flâne sur les marchés, on se promène dans les villes... mais on met aussi un point d'honneur à ce que le voyage se fasse dans la bonne ambiance, avec des gens qui se ressemblent, se reconnaissent, et se sentent à leur place."
  },
  "about_generations": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "« Des générations qui se croisent » — texte",
    "def": "Trente ans d'histoire, ça veut dire beaucoup de voyages, beaucoup de familles, beaucoup de générations qui se croisent. Des enfants qui grandissent, des parents qui reviennent, des mamans qui voyageaient déjà, et qui reviennent maintenant avec leur propre enfant de 8 ans, comme elles l'étaient elles-mêmes."
  },
  "about_treve": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "« La trêve du voyage » — texte",
    "def": "Entre Lyon et Saint-Étienne, il y a un derby, des rivaux, des maillots, des souvenirs sportifs... mais dans le car, on fait la paix :"
  },
  "about_treve_dedans": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "« Dedans… » — texte",
    "def": "Tout le monde joue dans la même équipe, celle du voyage, de la bonne humeur et des connivences."
  },
  "about_bons_moments": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "« On laisse la vie s'occuper des bons moments » — texte",
    "def": "On prévoit les itinéraires, les hôtels, les repas, les transports... mais on laisse la vie s'occuper des bons moments : un rire dans le car, une discussion autour d'un café, une anecdote qui revient plusieurs fois, et parfois, cette phrase qui revient en boucle :"
  },
  "about_conclusion": {
    "groupe": "Qui sommes-nous — L'ambiance",
    "label": "Conclusion (encadré bleu) — texte",
    "def": "Chez RHÔNE AMITIÉ VOYAGES, le voyage, oui. La rencontre, le partage, l'ambiance, la trêve dans le car, les générations qui se croisent, et surtout, l'idée de partir ensemble, sans peur de ne pas être à sa place, c'est tout ça qu'on aime transmettre."
  },
  "about_aventures": {
    "groupe": "Qui sommes-nous — Aventures, retrouvailles, équipe",
    "label": "« 30 ans d'aventures » — texte",
    "def": "Depuis 1997, nos voyageurs ont posé leurs valises aux quatre coins du monde. De la **Rép. Dominicaine** aux **Émirats**, en passant par **l'Italie**, **le Maroc** et les **croisières sur le Nil** — chaque destination est une histoire, chaque voyage une amitié qui se renforce."
  },
  "about_retrouvailles_1": {
    "groupe": "Qui sommes-nous — Aventures, retrouvailles, équipe",
    "label": "Retrouvailles 2027 — paragraphe 1",
    "def": "En **2027**, Rhône Amitié Voyages fêtera ses **30 ans**. Pour marquer cet anniversaire, nous préparons un événement spécial et nous aimerions retrouver celles et ceux qui ont voyagé avec nous au fil de ces trois décennies."
  },
  "about_retrouvailles_2": {
    "groupe": "Qui sommes-nous — Aventures, retrouvailles, équipe",
    "label": "Retrouvailles 2027 — paragraphe 2",
    "def": "Vous avez un **souvenir mémorable** ? Une **anecdote de voyage** ? Un **fou rire inoubliable** dans l'autocar ? Vous étiez enfant et vous êtes devenu(e) parent depuis ? Racontez-nous ! Chaque histoire compte et pourrait figurer dans notre livre de souvenirs des 30 ans."
  },
  "about_equipe_encadre": {
    "groupe": "Qui sommes-nous — Aventures, retrouvailles, équipe",
    "label": "Équipe — encadré vert",
    "def": "**Vous n'êtes jamais livré à vous-même :** si vous avez un doute sur un document, une démarche à faire (renouveler un passeport, vérifier un vaccin, remplir un formulaire), nous vous guidons **pas à pas**, principalement via **WhatsApp** pour plus de réactivité."
  },
  "about_france_1": {
    "groupe": "Qui sommes-nous — Ouverture & fin de page",
    "label": "Ouverte à toute la France — paragraphe 1",
    "def": "Dès sa création, Rhône Alpes Amitié Voyages a fait le choix de **ne pas s'attacher à une commune ou une ville en particulier**. Ce n'est pas un comité des fêtes ou un club de quartier : c'est une association de voyageurs, ouverte à tous, sans frontière géographique."
  },
  "about_france_2": {
    "groupe": "Qui sommes-nous — Ouverture & fin de page",
    "label": "Ouverte à toute la France — paragraphe 2",
    "def": "Et ça se ressent ! Aujourd'hui, **nos participants viennent de toute la France** : de la région lyonnaise bien sûr, mais aussi de Paris, Marseille, Bordeaux, Toulouse, Nantes, Strasbourg et bien d'autres villes. Ce qui les attire, ce n'est pas un tarif imbattable — c'est **l'ambiance Rhône-Amitié**."
  },
  "about_france_3": {
    "groupe": "Qui sommes-nous — Ouverture & fin de page",
    "label": "Ouverte à toute la France — paragraphe 3",
    "def": "Cette convivialité unique, cette façon de voyager entre amis même quand on ne se connaît pas encore, c'est ce qui fait revenir les gens, année après année. Et c'est aussi ce qui rend le **départ depuis l'aéroport de Lyon** si naturel : pour beaucoup, c'est l'occasion de se retrouver, de partager un café avant l'embarquement et de commencer le voyage avant même de décoller."
  },
  "about_france_encadre": {
    "groupe": "Qui sommes-nous — Ouverture & fin de page",
    "label": "Ouverte à toute la France — encadré",
    "def": "Vous habitez loin de Lyon ? Aucun souci — nos voyageurs viennent de partout et se sentent chez eux dès le premier jour. C'est ça, l'esprit Rhône-Amitié."
  },
  "about_whatsapp": {
    "groupe": "Qui sommes-nous — Ouverture & fin de page",
    "label": "Bandeau WhatsApp — texte",
    "def": "C'est par WhatsApp que nous envoyons les programmes détaillés, les rappels, les documents administratifs, les confirmations et les réponses rapides à vos questions."
  },
  "ip_intro_titre": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Encadré bleu — titre",
    "def": "Tout passe par le formulaire d'inscription en ligne"
  },
  "ip_intro": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Encadré bleu — texte",
    "def": "Que vous soyez chez vous ou avec nous lors d'un rendez-vous, l'inscription se fait sur le même formulaire. Pas besoin d'imprimer quoi que ce soit. Si vous n'êtes pas à l'aise avec Internet, nous sommes là pour vous accompagner par téléphone, par WhatsApp ou en personne."
  },
  "ip_etape1": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Étape 1 — texte",
    "def": "En ligne depuis chez vous, ou sur nos tablettes lors d'un rendez-vous. 1 formulaire par foyer (même adresse)."
  },
  "ip_etape2": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Étape 2 — texte",
    "def": "Nous acceptons 6 modes de paiement : carte bancaire, virement, chèque, espèces, chèques-vacances ANCV et avoir (suite à une annulation antérieure)."
  },
  "ip_etape3": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Étape 3 — texte",
    "def": "Depuis votre Espace Adhérent, à distance : virement (recommandé), carte bancaire, chèques-vacances papier par courrier (adresse sur demande par WhatsApp). Pas de chèque bancaire par courrier. Espèces et chèques-vacances papier en main propre : uniquement sur rendez-vous à la permanence."
  },
  "ip_distance_1": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "« 100 % à distance » — ligne 1",
    "def": "Formulaire + règlement sans vous déplacer, depuis votre Espace Adhérent"
  },
  "ip_distance_2": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "« 100 % à distance » — ligne 2",
    "def": "Virement (recommandé), carte bancaire, chèques-vacances papier (adresse sur demande)"
  },
  "ip_rdv_1": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "« En rendez-vous » — ligne 1",
    "def": "Règlement sur place en **espèces** ou **chèques-vacances papier** — reçu et facture immédiats"
  },
  "ip_rdv_2": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "« En rendez-vous » — ligne 2",
    "def": "Pas de terminal CB : carte bancaire et virement se font 100 % en ligne, sans vous déplacer. Le formulaire d'inscription se remplit en ligne avant le rendez-vous."
  },
  "ip_permanence_adresse": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Permanences — adresse / accès",
    "def": "332 avenue Général de Gaulle, 69500 Bron — entrée côté magasin Grand Frais, montez les escalators, puis sur votre gauche."
  },
  "ip_important": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Encadré rouge « Important »",
    "def": "**Important :** L'inscription n'est validée qu'une fois le formulaire rempli ET le règlement effectué (en ligne ou en rendez-vous) dans les 24 heures."
  },
  "ip_aide": {
    "groupe": "Infos pratiques — Comment s'inscrire",
    "label": "Encadré « Besoin d'aide ? »",
    "def": "**Besoin d'aide ?** Si vous n'êtes pas à l'aise avec le formulaire en ligne, nous pouvons vous guider pas à pas par téléphone ou par WhatsApp. Nous sommes aussi disponibles par email."
  },
  "ip_accomp_intro": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Accompagnement — phrase d'intro",
    "def": "Nous ne nous contentons pas de vendre un voyage : nous aidons aussi à préparer le dossier."
  },
  "ip_accomp_fin": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Accompagnement — encadré de fin",
    "def": "Tout cela se fait principalement par **WhatsApp** (messages, vocaux, pièces jointes), complété si besoin par téléphone ou rendez-vous. **Vous n'êtes pas seul face aux démarches.**"
  },
  "ip_adhesion": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Adhésion annuelle — texte",
    "def": "Comme dans de nombreuses structures associatives, une **adhésion annuelle** au montant modeste est demandée. Elle est valable **par foyer** et contribue au fonctionnement général de l'association. L'inscription devient définitive lorsque le formulaire est rempli et qu'un premier règlement a été enregistré."
  },
  "ip_adhesion_journee": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Adhésion annuelle — phrase journée",
    "def": "L'adhésion n'est pas obligatoire pour les voyages à la journée."
  },
  "ip_assurance_1": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Assurance — paragraphe Groupama",
    "def": "Grâce à notre partenariat avec **Groupama**, bénéficiez d'une couverture complète pour votre voyage à des tarifs préférentiels. L'assurance vous protège contre les imprévus et vous permet de voyager l'esprit tranquille."
  },
  "ip_assurance_2": {
    "groupe": "Infos pratiques — Accompagnement, adhésion, assurance",
    "label": "Assurance — « Bon à savoir »",
    "def": "**Bon à savoir :** L'assurance n'est pas obligatoire, mais fortement recommandée pour vous protéger en cas d'annulation, d'accident ou de maladie."
  },
  "ip_vfast_intro": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — phrase d'intro",
    "def": "Nous conseillons toujours de vérifier ces cinq points avant de s'inscrire — dans l'ordre, en commençant toujours par le **Voyage** lui-même."
  },
  "ip_vfast_voyage": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — Voyage (question)",
    "def": "Avez-vous bien pris connaissance de TOUT ce qui concerne ce voyage précis ?"
  },
  "ip_vfast_famille": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — Famille",
    "def": "Qui s'occupe de vos proches, animaux, responsabilités pendant votre absence ?"
  },
  "ip_vfast_argent": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — Argent",
    "def": "Le budget est-il cohérent, même avec un paiement en plusieurs fois ?"
  },
  "ip_vfast_sante": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — Santé",
    "def": "Votre état est-il compatible avec le voyage (climat, marche, décalage horaire) ?"
  },
  "ip_vfast_travail": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — Travail",
    "def": "Vos congés sont-ils bien validés par votre employeur ?"
  },
  "ip_vfast_fin": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "V.F.A.S.T. — encadré de fin",
    "def": "En cas de doute sur l'un de ces cinq points, nous préférons en discuter avant d'enregistrer une inscription. Un simple message WhatsApp suffit pour entamer l'échange."
  },
  "ip_annulation_pourquoi": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "Frais d'annulation — explication",
    "def": "Dès votre inscription, nous réservons et payons nos prestataires (hôtels, transporteurs, etc.) selon un échéancier précis. Les frais d'annulation correspondent aux sommes déjà engagées auprès d'eux à la date de votre annulation. C'est pourquoi il est important de respecter l'échéancier de paiement : ce que nous versons à nos prestataires ne peut plus être récupéré."
  },
  "ip_annulation_logique": {
    "groupe": "Infos pratiques — Avant de réserver & frais d'annulation",
    "label": "Frais d'annulation — « Vous voyez la logique ? »",
    "def": "**Vous voyez la logique ?** L'échéancier de paiement (20% à l'inscription, 50% à 6 mois, solde à 45 jours) correspond directement à ce que nous versons aux prestataires. Si vous annulez, les frais reflètent ce qui a déjà été engagé. D'où l'intérêt de souscrire à l'assurance annulation dès l'inscription !"
  }
};
